import { Link, useNavigate } from 'react-router-dom';
import { loginUser, sendVerificationEmail, validateLoginText } from '../../service/login';
import { useState, useEffect, usecall } from 'react';
import {
    Box,
    Button,
    IconButton,
    InputAdornment,
    Paper,
    TextField,
    Typography,
    Link as MuiLink,
    Snackbar,
    Alert,
    Dialog,
    DialogContent,
    Stack,
    MenuItem,
} from '@mui/material';
import { Visibility, VisibilityOff, MailOutline, LockOutlined, Language, ArrowForward, Email } from '@mui/icons-material';
import ISOIcon from '../../assets/iso.svg';
import rvceLogo from '../../assets/Logo-2.png';
import WFMHIcon from '../../assets/wfmh.svg';
import HIPAAIcon from '../../assets/hipa.svg';
import EchoHome from './echoHome';
import { getUserByEmail, SignupUser } from '../../service/user';

function LoginPage() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [userId, setUserId] = useState(null);

    const [error, setError] = useState("");
    const [institution, setInstitution] = useState("");
    const [emailVerified, setEmailVerified] = useState(false);
    const [showEchoHome, setShowEchoHome] = useState(
        localStorage.getItem("showEchoHome") === "true"
    );
    const [showVerificationModal, setShowVerificationModal] = useState(false);
    const [hasStoredInstitution, setHasStoredInstitution] = useState(false);
    const [hasCheckedUser, setHasCheckedUser] = useState(false);
    const [userExists, setUserExists] = useState(false);
    const [verificationEmail, setVerificationEmail] = useState("");
    const [passwordError, setPasswordError] = useState("");
    // New user registration fields
    const [fullName, setFullName] = useState("");
    const [gender, setGender] = useState("");
    const [phone, setPhone] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    useEffect(() => {
        console.log("Password updated:", password);
    }, [password]);

    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "info",
    });

    const navigate = useNavigate();

    useEffect(() => {
        const storedInstitution = localStorage.getItem("institution");
        const storedDomain = localStorage.getItem("domain");
        const storedEmail = localStorage.getItem("email");
        const storedIsEmailVerified = localStorage.getItem("isEmailVerified");

        if (storedInstitution && storedDomain) {
            setHasStoredInstitution(true);
            setInstitution(storedInstitution);
        }

        // 🔥 NEW CONDITION
        if (
            storedInstitution &&
            storedDomain &&
            storedEmail &&
            storedIsEmailVerified === "0" // not verified
        ) {
            setEmail(storedEmail);
            setShowEchoHome(true);
        }

    }, []);

    const handleLogin = async () => {
        console.log("Login attempt with:", { email, password: "***" });
        setError(""); // Clear previous errors

        try {
            const finalEmail = buildFinalEmail();

            if (!finalEmail) {
                setError("Domain missing. Please reselect institution.");
                return;
            }

            const result = await loginUser(finalEmail, password);


            console.log("Login API Response:", result);

            if (result.success && result.data) {

                const userData = result.data.user || result.data;
                console.log("Extracted user data:", userData);


                if (!userData.is_email_verified) {

                    setEmailVerified(false);
                    setError("Please verify your email");
                    return;
                }

                console.log("Email verified, proceeding with login");
                setEmailVerified(true); // Mark as verified

                const cachedDomain = localStorage.getItem("domain");
                if (cachedDomain) {
                    localStorage.setItem("userEmailDomain", cachedDomain);
                }
                localStorage.setItem("isEmailVerified", userData.is_email_verified ? "1" : "0");
                localStorage.setItem("credentialsCacheTime", Date.now().toString());

                // Store user data in localStorage (same as login.jsx)
                localStorage.setItem("user", JSON.stringify(userData));
                localStorage.setItem("user_id", userData.id);
                localStorage.setItem("email", finalEmail); // Store the email
                localStorage.setItem("package_type", userData?.package_type);
                localStorage.setItem("account_type", userData?.account_type);
                localStorage.setItem("yoga_terms_conditions", userData?.yoga_terms_conditions);
                localStorage.setItem("account_id", userData?.account_id);

                // Extract and store first name (same as login.jsx)
                if (userData.name) {
                    const firstName = userData.name.trim().split(' ')[0];
                    console.log("Extracted first name:", firstName);
                    localStorage.setItem("user_name", firstName);

                    // Update the stored user object with just the first name
                    userData.name = firstName;
                    localStorage.setItem("user", JSON.stringify(userData));
                }

                // Set expiry time (same as login.jsx)
                const expiryTime = new Date().getTime() + 30 * 24 * 60 * 60 * 1000; // 30 days
                localStorage.setItem("userExpiry", expiryTime.toString());
                console.log("User stored in localStorage");
                setError("");

                // Navigate based on terms conditions (same as login.jsx)
                if (userData.yoga_terms_conditions === false) {
                    console.log("Navigating to yoga terms");
                    navigate('/yoga-terms');
                } else {
                    console.log("Navigating to home");
                    navigate("/");
                }
            } else {
                console.log("Login failed:", result.error);

                if (result.error.includes("not found") || result.error.includes("404")) {
                    setError("Account not found. Please check your credentials.");
                } else if (result.error.includes("password") || result.error.includes("invalid")) {
                    setError("Invalid email or password. Please try again.");
                } else if (result.error.includes("HTTP error")) {
                    setError("Unable to connect to our services. Please try again in a moment.");
                } else {
                    setError("Login failed. Please check your credentials and try again.");
                }
            }
        } catch (error) {
            console.error("Login error:", error);
            setError("Network error. Please try again.");
        }
    };

    const handleClose = (_, reason) => {
        if (reason === "clickaway") return; // Prevent closing when clicked outside
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const handleInstitutionContinue = async () => {
        setError("");
        const result = await validateLoginText(institution);

        if (result?.success && result?.data) {
            console.log("result in function", result)

            const institutionValue = result.data.login_text;
            const domainValue = result.data.login_domain;

            if (!domainValue) {
                setError("Domain not configured for this institution");
                return;
            }

            localStorage.setItem("institution", institutionValue);
            localStorage.setItem("domain", domainValue);
            setHasStoredInstitution(true);

            setInstitution(institutionValue);
            // setShowLogin(true);

        } else {
            setSnackbar({
                open: true,
                message: "No Records Found",
                severity: "error"
            });
        }
    };

    const buildFinalEmail = () => {
        const cachedDomain = localStorage.getItem("domain");
        let finalEmail = email.trim();

        if (!finalEmail.includes("@")) {
            if (!cachedDomain) return null;
            finalEmail = `${finalEmail}@${cachedDomain}`;
        }

        return finalEmail;
    };

    if (showEchoHome) {
        return (
            <EchoHome setShowEchoHome={setShowEchoHome} />
        );
    }

    const handleSendVerification = async () => {
        const finalEmail = buildFinalEmail();

        if (!finalEmail) {
            setError("Domain missing. Please reselect institution.");
            return;
        }

        const result = await sendVerificationEmail({
            institution,
            enrollmentId: email,
            password: password,
            user_id: userId
        });

        console.log("API response:", result);

        // 🔴 If password is invalid
        if (!result.success) {
            setPasswordError("Incorrect password");
            setShowEchoHome(false);
            return; // stop execution here
        }

        // ✅ Clear error if success
        setPasswordError("");

        if (finalEmail) {
            localStorage.setItem("email", finalEmail);
        }

        if (result.user) {
            localStorage.setItem("user", JSON.stringify(result.user));
        }


        if (result.data) {
            const { institution, domain, isEmailVerified } = result.data;

            if (institution) localStorage.setItem("institution", institution);
            if (domain) localStorage.setItem("domain", domain);

            localStorage.setItem(
                "isEmailVerified",
                isEmailVerified ? "1" : "0"
            );

            setEmailVerified(isEmailVerified);
        }

        setVerificationEmail(finalEmail);

        if (userExists === true) {
            setShowVerificationModal(false);
            setShowEchoHome(true);
            localStorage.setItem("showEchoHome", "true");
        } else {
            setShowVerificationModal(true);
        }
    };

    const handleCheckUser = async () => {
        try {
            const finalEmail = buildFinalEmail();

            if (!finalEmail) {
                setError("Domain missing. Please reselect institution.");
                return;
            }

            const userData = await getUserByEmail(finalEmail);

            console.log("User API response:", userData);
            setUserId(userData?.id)

            localStorage.setItem("email", finalEmail);

            setHasCheckedUser(true);
            setUserExists(!!userData?.exists);

        } catch (error) {
            console.error("User check failed:", error);
            setHasCheckedUser(true);
            setUserExists(false);
        }
    };

    // const handleRegistration = async () => {
    //     try {
    //         setError("");

    //         // Validation
    //         if (!fullName || !gender || !phone || !newPassword || !confirmPassword) {
    //             setError("All fields are required");
    //             return;
    //         }

    //         if (newPassword !== confirmPassword) {
    //             setError("Passwords do not match");
    //             return;
    //         }

    //         if (newPassword.length < 6) {
    //             setError("Password must be at least 6 characters long");
    //             return;
    //         }

    //         const finalEmail = buildFinalEmail();
    //         if (!finalEmail) {
    //             setError("Domain missing. Please reselect institution.");
    //             return;
    //         }

    //         const userData = {
    //             loginText: institution,
    //             email: finalEmail,
    //             fullName: fullName,
    //             gender: gender,
    //             phone: phone,
    //             password: newPassword,
    //         };

    //         console.log("Registration data:", userData);

    //         const result = await SignupUser(userData);
    //         console.log("Registration API response:", result);

    //         if (result.success) {
    //             // Reset form fields
    //             setFullName("");
    //             setGender("");
    //             setPhone("");
    //             setNewPassword("");
    //             setConfirmPassword("");

    //             // Send verification email
    //             setTimeout(() => {
    //                 handleSendVerification();
    //             }, 2000);
    //         } else {
    //             setError(result.error || "Registration failed");
    //         }

    //     } catch (error) {
    //         console.error("Registration error:", error);
    //         setError("Network error. Please try again.");
    //     }
    // };


    const handleRegistration = async () => {
        try {
            setError("");

            // Validation
            if (!fullName || !gender || !newPassword || !confirmPassword) {
                setError("All fields are required");
                return;
            }

            if (newPassword !== confirmPassword) {
                setError("Passwords do not match");
                return;
            }

            if (newPassword.length < 6) {
                setError("Password must be at least 6 characters long");
                return;
            }

            const finalEmail = buildFinalEmail();
            if (!finalEmail) {
                setError("Domain missing. Please reselect institution.");
                return;
            }

            const userData = {
                loginText: institution,
                email: finalEmail,
                fullName: fullName,
                gender: gender,
                password: newPassword,
                ...(phone && { phone: phone }), // Only include phone if it's provided
            };

            console.log("Registration data:", userData);

            const result = await SignupUser(userData);
            console.log("Registration API response:", result);

            if (result.user) {
                localStorage.setItem("user", JSON.stringify(result.user));
            }

            if (result.success) {
                setUserId(result.user.id);
                localStorage.setItem("user", JSON.stringify(result.user));

                setUserId(result.user.id);

                // Reset form
                setFullName("");
                setGender("");
                setPhone("");
                setNewPassword("");
                setConfirmPassword("");

                setShowVerificationModal(true);

            } else {
                setError(result.error || "Registration failed");
            }
        } catch (error) {
            console.error("Registration error:", error);
            setError("Network error. Please try again.");
        }
    };

    return (

        <Box

            //  sx={{
            //     minHeight: '100vh',
            //     display: 'flex',
            //     alignItems: 'center',
            //     justifyContent: 'center',
            //     // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            //     background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
            //     p: 2,
            //     position: 'relative',
            //     overflow: 'hidden'
            // }}
            sx={{
                minHeight: '100dvh',            // dvh follows the visible area when the keyboard opens
                display: 'flex',
                flexDirection: { xs: 'column', md: 'row' },
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #f8fffe 0%, #f5f3ff 100%)',
                p: 2,
                position: 'relative',
                overflow: 'hidden'
            }}

        >
            {/* 🔥 Top Left Branding */}
            <Box
                // sx={{
                //     position: 'absolute',
                //     top: 20,
                //     left: 24,
                //     zIndex: 10,
                //     display: 'flex',
                //     alignItems: 'center'
                // }}

                sx={{
                    position: { xs: 'relative', md: 'absolute' },
                    top: { md: 20 },
                    left: { md: 24 },
                    alignSelf: { xs: 'flex-start', md: 'auto' },
                    mb: { xs: 2, md: 0 },
                    zIndex: 10,
                    display: 'flex',
                    alignItems: 'center'
                }}
            >
                <Link
                    to="/"
                    style={{
                        textDecoration: 'none',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Box
                        component="img"
                        src="/diginxthlt-logo.svg"
                        alt="Echo Logo"
                        sx={{
                            height: 45,
                            width: 45,
                            mr: 1,
                        }}
                    />

                    <Box>
                        <Typography
                            sx={{
                                fontSize: '1.4rem',
                                fontWeight: 700,
                                letterSpacing: '0.5px',
                                color: "#7843f3",
                                lineHeight: 1.1,
                            }}
                        >
                            echoShine
                        </Typography>

                        <Typography
                            sx={{
                                fontSize: '0.7rem',
                                fontWeight: 500,
                                letterSpacing: '0.3px',
                                color: "#7843f3",
                                lineHeight: 1.1,
                            }}
                        >
                            Connect. Heal. Rise.
                        </Typography>
                    </Box>
                </Link>
                {institution && institution.toLowerCase() === 'rvce' && (
                    <Box
                        component="img"
                        src={rvceLogo}
                        alt="RVCE"
                        sx={{ height: 55, width: 'auto', objectFit: 'contain', ml: 1 }}
                    />
                )}
            </Box>



            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    pointerEvents: 'none',
                    zIndex: 0,
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        width: 400,
                        height: 400,
                        borderRadius: '50%',
                        top: -100,
                        right: -100,
                        background: 'linear-gradient(135deg, #2ECC71, #1ABC9C)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '0s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 300,
                        height: 300,
                        borderRadius: '50%',
                        bottom: -50,
                        left: -50,
                        background: 'linear-gradient(135deg, #1ABC9C, #9B59B6)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-5s',
                    }}
                />
                <Box
                    sx={{
                        position: 'absolute',
                        width: 200,
                        height: 200,
                        borderRadius: '50%',
                        top: '50%',
                        left: '10%',
                        background: 'linear-gradient(135deg, #9B59B6, #A855F7)',
                        opacity: 0.1,
                        animation: 'float 20s infinite ease-in-out',
                        animationDelay: '-10s',
                    }}
                />
            </Box>

            {/* Left Side Content */}
            <Box sx={{
                display: { xs: 'none', md: 'flex' },
                flexDirection: 'column',
                color: 'white',
                maxWidth: '50%',
                p: 4,
                zIndex: 1
            }}>
                <Typography
                    sx={{
                        mt: 1,
                        fontSize: 26,
                        fontWeight: 700,
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                        lineHeight: 1.3,
                    }}
                >
                    Shine. Thrive. Succeed.
                </Typography>
                <Typography
                    sx={{
                        mt: 2.5,
                        maxWidth: 560,
                        lineHeight: 1.7,
                        fontWeight: 500,
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                    }}
                >
                    Streamline your care journey with our AI-powered mental wellness platform.
                </Typography>
                <Box sx={{ display: 'flex', mt: 5 }}>
                    <Box sx={{ textAlign: 'center', mr: 4 }}>
                        <img
                            src={ISOIcon}
                            alt="ISO Certified"
                            style={{ height: 60, width: 70, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
                        />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            ISO 27001<br />Certified
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', mr: 2 }}>
                        <img src={WFMHIcon} alt="WFMH Member" style={{ height: 60 }} />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            WFMH<br />Member
                        </Typography>
                    </Box>
                    <Box sx={{ textAlign: 'center', }}>
                        <img
                            src={HIPAAIcon}
                            alt="HIPAA Compliant"
                            style={{ height: 50, filter: 'hue-rotate(90deg) saturate(1.2) brightness(1.1)' }}
                        />
                        <Typography sx={{ mt: 1, fontSize: 12, fontWeight: 500, opacity: 0.8, color: '#777', }}>
                            HIPAA<br />Compliant
                        </Typography>
                    </Box>
                </Box>
            </Box>



            {/* Login Form */}
            <Paper
                elevation={24}
                sx={{
                    width: '100%',
                    maxWidth: 520,
                    borderRadius: 4,
                    px: { xs: 3, md: 4 },
                    py: { xs: 3, md: 4 },
                    bgcolor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(20px)',
                    border: '1px solid rgba(0,0,0,0.05)',
                    boxShadow: '0 24px 40px rgba(0, 0, 0, 0.12)',
                    zIndex: 1,
                    mx: { xs: '16px', md: '32px' },
                    // my: hasCheckedUser && !userExists ? 8 : 0
                    my: { xs: 2, md: hasCheckedUser && !userExists ? 8 : 0 }

                }}
            >
                <Box
                    // component="form"
                    sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}

                >
                    <Box sx={{ textAlign: 'center', mb: 2 }}>
                        <Typography
                            sx={{
                                fontSize: { xs: 26, md: 30 },
                                fontWeight: 800,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            Welcome to echoShine
                        </Typography>
                        <Typography sx={{ color: '#64748B', fontSize: 14, mb: 1 }}>
                            Enter your Institution  to get started
                        </Typography>
                    </Box>

                    {hasStoredInstitution ? (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();

                                if (!hasCheckedUser) {
                                    handleCheckUser();
                                } else if (userExists) {
                                    handleSendVerification();
                                } else {
                                    handleRegistration();
                                }
                            }}
                        >
                            <Box sx={{ position: 'relative' }}>
                                <TextField
                                    label="Enrollment ID / Username *"
                                    variant="outlined"
                                    fullWidth
                                    value={email}
                                    InputLabelProps={{ shrink: true }}
                                    onChange={(e) => setEmail(e.target.value)}
                                    InputProps={{
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <MailOutline />
                                            </InputAdornment>
                                        )
                                    }}
                                // onKeyDown={(e) => {
                                //     if (e.key === 'Enter' && email && password) {
                                //         e.preventDefault();
                                //         handleLogin();
                                //     }
                                // }}
                                />

                                {hasCheckedUser && userExists === true && (
                                    <TextField
                                        fullWidth
                                        required
                                        label="Password"
                                        type={showPassword ? "text" : "password"}
                                        margin="normal"
                                        InputLabelProps={{ shrink: true }}
                                        value={password}
                                        error={!!passwordError}
                                        helperText={passwordError}
                                        onChange={(e) => {
                                            setPassword(e.target.value);
                                            setPasswordError(""); // clear error while typing
                                        }}
                                        // onKeyDown={(e) => {
                                        //     if (e.key === 'Enter' && password) {
                                        //         e.preventDefault();
                                        //         // handleSendVerification();
                                        //     }
                                        // }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton
                                                        onClick={() => setShowPassword(!showPassword)}
                                                        edge="end"
                                                    >
                                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                )}

                                {hasCheckedUser && userExists === false && (
                                    <>
                                        <TextField
                                            fullWidth
                                            label="Full Name"
                                            margin="normal"
                                            required
                                            value={fullName}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => {
                                                setFullName(e.target.value);
                                                setError("");
                                            }}
                                        />

                                        <TextField
                                            select
                                            required
                                            fullWidth
                                            label="Gender"
                                            margin="normal"
                                            value={gender}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => {
                                                setGender(e.target.value);
                                                setError("");
                                            }}
                                        >
                                            <MenuItem value="male">Male</MenuItem>
                                            <MenuItem value="female">Female</MenuItem>
                                            <MenuItem value="other">Other</MenuItem>
                                        </TextField>

                                        <TextField
                                            fullWidth
                                            label="Phone"

                                            margin="normal"
                                            value={phone}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => {
                                                setPhone(e.target.value);
                                                setError("");
                                            }}
                                        />

                                        <TextField
                                            fullWidth
                                            required
                                            label="Password"
                                            type={showPassword ? "text" : "password"}
                                            margin="normal"
                                            value={newPassword}
                                            InputLabelProps={{ shrink: true }}
                                            onChange={(e) => {
                                                setNewPassword(e.target.value);
                                                setError("");
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowPassword(!showPassword)}
                                                            edge="end"
                                                        >
                                                            {showPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                        {error && (
                                            <Typography
                                                color="error"
                                                sx={{ mt: 1, mb: 1, fontSize: "14px" }}
                                            >
                                                {error}
                                            </Typography>
                                        )}

                                        <TextField
                                            fullWidth
                                            required
                                            label="Confirm Password"
                                            type={showConfirmPassword ? "text" : "password"}
                                            margin="normal"
                                            InputLabelProps={{ shrink: true }}
                                            value={confirmPassword}
                                            onChange={(e) => {
                                                setConfirmPassword(e.target.value);
                                                setError("");
                                            }}
                                            InputProps={{
                                                endAdornment: (
                                                    <InputAdornment position="end">
                                                        <IconButton
                                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                            onMouseDown={(e) => e.preventDefault()}
                                                            edge="end"
                                                        >
                                                            {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                                        </IconButton>
                                                    </InputAdornment>
                                                ),
                                            }}
                                        />
                                    </>
                                )}
                            </Box>

                            <Box sx={{ textAlign: 'right', mt: 1 }}>

                                {/* 🔹 API NOT CALLED */}
                                {!hasCheckedUser && (
                                    <MuiLink
                                        component="button"
                                        type="button"
                                        // onClick={() => {
                                        //     localStorage.removeItem("institution");
                                        //     localStorage.removeItem("domain");
                                        //     localStorage.removeItem("email");
                                        //     localStorage.removeItem("isEmailVerified");
                                        //     localStorage.removeItem("credentialsCacheTime");
                                        //     localStorage.removeItem("user");
                                        //     localStorage.removeItem("userExpiry");

                                        //     setInstitution("");
                                        //     setEmail("");
                                        //     setEmailVerified(false);
                                        //     setShowLogin(false);
                                        //     setError("");
                                        //     setHasStoredInstitution(false);
                                        // }}
                                        onClick={() => {
                                            localStorage.clear();
                                            setHasStoredInstitution(false);
                                        }}
                                        sx={{
                                            color: '#6B7280',
                                            fontSize: 13,
                                            textDecoration: 'none',
                                            '&:hover': { textDecoration: 'underline' }
                                        }}
                                    >
                                        Update Institution?
                                    </MuiLink>
                                )}

                                {/* 🔹 API CALLED + USER EXISTS */}
                                {/* 🔹 API CALLED + USER EXISTS */}
                                {hasCheckedUser && userExists === true && (
                                    <MuiLink
                                        component="button"
                                        onClick={() => {
                                            console.log("Redirect to Forgot Password");
                                            window.location.href = "/forgotpassword";
                                        }}
                                        sx={{
                                            color: '#6B7280',
                                            fontSize: 13,
                                            textDecoration: 'none',
                                            '&:hover': { textDecoration: 'underline' }
                                        }}
                                    >
                                        Forgot Password?
                                    </MuiLink>
                                )}

                            </Box>

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={!email || (hasCheckedUser && ((userExists === true && !password) || (userExists === false && (!fullName || !gender || !newPassword || !confirmPassword))))}
                                // onClick={hasCheckedUser ? (userExists ? handleSendVerification : handleRegistration) : handleCheckUser}
                                sx={{
                                    borderRadius: 2,
                                    height: 48,
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    color: '#ffffff',
                                    fontSize: 16,
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    boxShadow: '0 8px 20px rgba(34,197,94,0.35)',
                                }}
                            >
                                {/* Verify Email */}
                                {!hasCheckedUser
                                    ? "Proceed to Login"
                                    : userExists
                                        ? "Continue to Login"
                                        : "Sign Up"}
                                <Email sx={{ ml: 1, fontSize: 18 }} />
                            </Button>
                        </form>

                    ) : (
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                handleInstitutionContinue();
                            }}
                        >
                            <TextField
                                fullWidth
                                label="Institution"
                                variant="outlined"
                                value={institution}
                                onChange={(e) => setInstitution(e.target.value)}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Language />
                                        </InputAdornment>
                                    )
                                }}
                            />

                            {error && (
                                <Typography variant="body2" sx={{ color: 'red', textAlign: 'center', mt: 1 }}>
                                    {error}
                                </Typography>
                            )}

                            <Button
                                type="submit"
                                variant="contained"
                                fullWidth
                                disabled={!institution}
                                // onClick={handleInstitutionContinue}
                                sx={{
                                    borderRadius: 2,
                                    mt: 2,
                                    height: 48,
                                    background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                    color: '#ffffff',
                                    fontSize: 16,
                                    fontWeight: 700,
                                    textTransform: 'none',
                                    boxShadow: '0 8px 20px rgba(34,197,94,0.35)',
                                }}
                            >
                                Continue
                                <ArrowForward sx={{ ml: 1, fontSize: 18 }} />
                            </Button>
                        </form>
                    )}

                    <Box sx={{ mt: 1, textAlign: 'center' }}>
                        <Typography sx={{ color: '#94A3B8', fontSize: 12 }}>
                            🛡️ Secured by <strong style={{ color: '#64748B' }}>DigiNxtHlt Solutions Pvt Ltd</strong>
                        </Typography>
                    </Box>
                </Box>
            </Paper>

            {/* Email verification dialog */}
            <Dialog
                open={showVerificationModal}
                onClose={() => setShowVerificationModal(false)}
                maxWidth="xs"
                fullWidth
                BackdropProps={{
                    sx: {
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(8px)',
                    }
                }}
                PaperProps={{
                    sx: {
                        borderRadius: 4,
                        p: 3,
                        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
                    }
                }}
            >
                <DialogContent sx={{ p: 0 }}>
                    <Box sx={{ textAlign: 'center', mb: 4 }}>
                        <Typography
                            sx={{
                                fontSize: 20,
                                fontWeight: 700,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                backgroundClip: 'text',
                            }}
                        >
                            Email Verification
                        </Typography>
                        <Typography
                            sx={{
                                fontSize: 13,
                                color: '#64748B',
                                mt: 1
                            }}
                        >
                            We've sent a verification link to your email. Please verify your email address to access all features.
                        </Typography>
                    </Box>
                    <Stack spacing={2}>
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={() => {
                                setShowVerificationModal(false);
                                setShowEchoHome(true);
                                localStorage.setItem("showEchoHome", "true");
                            }}
                            sx={{
                                py: 1.5,
                                borderRadius: 2,
                                textTransform: "none",
                                fontWeight: 600,
                                background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                                color: '#ffffff',
                                '&:hover': {
                                    background: 'linear-gradient(135deg, #16a34a, #0d9488, #7c3aed)',
                                }
                            }}
                        >
                            Proceed to Login
                        </Button>
                    </Stack>
                </DialogContent>
            </Dialog>

            <Snackbar
                open={snackbar.open}
                autoHideDuration={3000}
                onClose={handleClose}
                anchorOrigin={{ vertical: "top", horizontal: "right" }}
            >
                <Alert onClose={handleClose} severity={snackbar.severity} sx={{ width: "100%" }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>

            <Box
                // sx={{
                //     position: 'absolute',
                //     bottom: 12,
                //     left: '50%',
                //     transform: 'translateX(-50%)',
                //     textAlign: 'center',
                //     zIndex: 1,
                // }}
                   sx={{
                    position: { xs: 'static', md: 'absolute' },
                    bottom: { md: 12 },
                    left: { md: '50%' },
                    transform: { md: 'translateX(-50%)' },
                    mt: { xs: 3, md: 0 },
                    px: 2,
                    textAlign: 'center',
                    zIndex: 1,
                }}
            >
                <Typography
                    variant="body2"
                    sx={{
                        fontSize: 12,
                        fontWeight: 600,
                        letterSpacing: '0.3px',
                        background: 'linear-gradient(135deg, #22c55e, #14b8a6, #8b5cf6)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        backgroundClip: 'text',
                        display: 'inline-block',
                        lineHeight: 1.4,
                    }}
                >
                    © 2025 DigiNxtHlt Solutions Private Limited. All rights reserved.
                </Typography>
            </Box>

        </Box>
    );
}
export default LoginPage;
